import React, { useEffect, useState, useCallback } from "react";
import ProductCard from "../components/ProductCard";
import "../styles/products.css";
import { API_BASE } from "../config";
import trackPageView from "../utils/trackPageView";

const FALLBACK_PRODUCTS = [
  { _id: "1", name: "Basmati Rice & Cereals", category: "Export", description: "Premium-grade rice and cereal grains sourced for bulk export." },
  { _id: "2", name: "Handmade Textiles", category: "Export", description: "Traditional and modern textile goods, sourced from verified manufacturers." },
  { _id: "3", name: "Industrial Machinery", category: "Export", description: "Machinery parts and equipment for industrial buyers." },
  { _id: "4", name: "Spices & Condiments", category: "Export", description: "Bulk spices and condiments, quality-checked before shipment." },
  { _id: "5", name: "Electronic Components", category: "Import", description: "Sourced electronic parts and components for local distribution." },
  { _id: "6", name: "Auto Spare Parts", category: "Import", description: "Genuine and aftermarket auto parts, imported and inspected." },
];

const ITEMS_PER_PAGE = 12;

function Products() {
  const [products, setProducts] = useState(FALLBACK_PRODUCTS);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [usingFallback, setUsingFallback] = useState(true);

  const fetchProducts = useCallback(async (pageNum) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/products?page=${pageNum}&limit=${ITEMS_PER_PAGE}`);
      const json = await res.json();
      if (json.data && json.data.length > 0) {
        setProducts(json.data);
        setTotalPages(json.totalPages);
        setUsingFallback(false);
      }
    } catch (err) {
      if (pageNum === 1) setUsingFallback(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    trackPageView("products");
    fetchProducts(1);
  }, [fetchProducts]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchProducts(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="products-page">
      <section className="page-header">
        <h1>Our Products</h1>
        <p>Browse what we import and export. Tap a product to enquire on WhatsApp.</p>
      </section>

      <section className="products-grid">
        {loading && <p className="loading-text">Loading products...</p>}
        {products.map((p) => (
          <ProductCard
            key={p._id}
            {...p}
          />
        ))}
      </section>

      {!usingFallback && totalPages > 1 && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Prev
          </button>
          <span className="pagination-info">
            Page {page} of {totalPages}
          </span>
          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </main>
  );
}

export default Products;
